import React, { useEffect } from "react";
import images from "../data/image.json";
import { Card } from "react-bootstrap";
import ImageWorker from "../workers/imageWorker.worker.js"; // Import the worker

export default function ImageSelect({
  selectedImage = "",
  onSelectImage = () => {},
}) {
  useEffect(() => {
    const worker = new ImageWorker();

    // Send the image URLs to the worker
    const imageUrls = images.map((item) => item.full);
    worker.postMessage(imageUrls);

    // Clean up the worker on component unmount
    return () => {
      worker.terminate();
    };
  }, []);

  return (
    <div className="grid grid-cols-4 gap-3" data-selected-image={selectedImage}>
      {images.map((item) => (
        <Card
          key={item.full}
          className={`template ${
            selectedImage === item.full ? "template--selected" : ""
          }`}
          onClick={() => {
            onSelectImage(item.full);
          }}
        >
          <Card.Img
            variant={"top"}
            src={item.thumb}
            loading={"lazy"}
            width={1127}
            height={2437}
          />
        </Card>
      ))}
    </div>
  );
}
